
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tv/[pageSection]/[pageCategory]",
      function () {
        return require("private-next-pages/tv/[pageSection]/[pageCategory].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tv/[pageSection]/[pageCategory]"])
      });
    }
  